import Image from 'next/image'
const Sun = () => {
  return (
    <Image
      alt='Sun'
      priority
      src={'../sun.svg'}
      width={24}
      height={24}
      title='Sun'
    />
  )
}

export default Sun
